var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.72505 3.72407C3.96913 3.48 4.36486 3.48 4.60893 3.72407L10.0003 9.11547L15.3917 3.72407C15.6358 3.48 16.0315 3.48 16.2756 3.72407C16.5197 3.96815 16.5197 4.36388 16.2756 4.60796L10.8842 9.99935L16.2756 15.3907C16.5197 15.6348 16.5197 16.0305 16.2756 16.2746C16.0315 16.5187 15.6358 16.5187 15.3917 16.2746L10.0003 10.8832L4.60893 16.2746C4.36486 16.5187 3.96913 16.5187 3.72505 16.2746C3.48097 16.0305 3.48097 15.6348 3.72505 15.3907L9.11644 9.99935L3.72505 4.60796C3.48097 4.36388 3.48097 3.96815 3.72505 3.72407Z",
    fill: "#798692"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.dd64538d24d8997f079236da05f2e74c.svg";
export { ForwardRef as ReactComponent };